

const CounterType =  
        {
            Users :"Users",
            Vehicles:"Vehicles",
            Equipments:"Equipments",
            Operators:"Operators"
        };

export default CounterType;